// extracted by mini-css-extract-plugin
export default {"input-container":"components-payment-modal-recurring-payment-method-module__input-container","footer":"components-payment-modal-recurring-payment-method-module__footer"};